









































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  getCountAfterSale,
  getCountAwaitPay,
  getCountAwaitSend,
} from "@/api/order";

@Component
export default class Tag extends Vue {
  @Prop() private orderStatus!: number;
  @Prop() private summary: any;
  tagOrderStatus: number = 20;
  afterSale: number = 0;
  awaitPay: number = 0;
  awaitSend: number = 0;
  @Watch("orderStatus")
  searchValue() {
    this.tagOrderStatus = this.orderStatus;
  }
  mounted() {
    this.getData();
  }

  getData() {
    getCountAfterSale().then((res: any) => {
      this.afterSale = res.data;
    });

    getCountAwaitPay().then((res: any) => {
      this.awaitPay = res.data;
    });

    getCountAwaitSend().then((res: any) => {
      this.awaitSend = res.data;
    });
  }
}
